export default __webpack_public_path__ + "images/439d203f27df208e769102435ef483a8-lacross_small.webp";